import * as yup from 'yup';

import type { ScheduleAddress } from '@shared/types/schedules';

export interface AddressForm {
	city: string;
	street: string;
	house: string;
	apartment: string;
	phone: string;
	note: string;
}

export const schema = yup.object().shape({
	address: yup.object().shape({
		city: yup.string().required('Укажите город').typeError('Укажите город'),
		street: yup.string().required('Укажите улицу').typeError('Укажите улицу'),
		house: yup.string().required('Укажите номер дома').typeError('Укажите номер дома'),
		apartment: yup
			.string()
			.required('Укажите номер квартиры/офиса')
			.typeError('Укажите номер квартиры/офиса'),
		phone: yup.string().required('Телефон не указан').min(6, 'Телефон слишком короткий').nullable(),
	}),
});

const findMaxOrder = (list: ScheduleAddress[]) => {
	return list.length
		? Number(list.reduce((prev, cur) => (+prev.order > +cur.order ? prev : cur)).order) + 1
		: 0;
};

export const normalizeScheduleAddress = (address: any, list: ScheduleAddress[]) => {
	const normalize = {
		order: findMaxOrder(list),
		city: address.address.city ?? '',
		street: address.address.street ?? '',
		house: address.address.house ?? '',
		apartment: address.address.apartment ?? '',
		phone: address.address.phone ?? '',
		note: address.address.note ?? '',
		visible: true,
	};
	return normalize;
};

export const defaultAddressValue: AddressForm = {
	city: '',
	street: '',
	house: '',
	apartment: '',
	phone: '',
	note: '',
};
